<template>
  <div class="hero">
    <div class="hero__container">
      <div class="layout-img">
        <img src="layout-hero.png" alt="" />
      </div>
      <div
        class="hero__animation-left"
        :class="{ 'hero__animation-left--ar': lang === 'ar' }"
      >
        <inline-svg :src="require('@/assets/svg/hero-animation-left.svg')" />

        <lottie-animation
          path="assets/lottie/kreiselement.json"
          class="lottie"
          :loop="false"
          :autoPlay="false"
          :speed="1"
          @AnimControl="setCircleController"
        />
      </div>
      <div class="hero__center" :class="{ 'hero__center--ar': lang === 'ar' }">
        <div class="hero__center-graphic">
          <LazyImage :src="'assets/img/hero-center-image.jpg'" ref="image" />
          <inline-svg
              :src="require('@/assets/svg/hero-center-graphic.svg')"
            />

          <div class="hero__center-graphic-lottie" v-view="viewHandler">
            <!-- <inline-svg
              :src="require('@/assets/svg/hero-center-graphic.svg')"
            />
            <lottie-animation
              path="assets/lottie/Linie_2.json"
              class="lottie"
              :loop="false"
              :autoPlay="false"
              :speed="1"
              @AnimControl="setAnimController"
            /> -->
          </div>
        </div>
        <div class="hero__center-rect" ref="rect"></div>

        <div class="hero__center-hl" ref="headline">
          <h1 class="hero-p">{{ getText("hero_headline") }}</h1>
        </div>
      </div>
      <!--<inline-svg :src="require('@/assets/svg/logo.svg')" />-->
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ContentMixin from "@/mixins/ContentMixin";
import LazyImage from "@/components/LazyImage";
export default {
  name: "Hero",
  mixins: [ContentMixin],
  components: { LazyImage },
  props: {},
  data() {
    return {
      circleAnimation: undefined,
      lineAnimation: undefined,
      lineAnimationStarted: undefined,
      shown: false,
    };
  },
  computed: {},
  watch: {
    textbooklet() {
      this.show();
    },
    lang() {
      this.show();
    },
  },
  methods: {
    show() {
      this.shown = true;
      if (this.circleAnimation) {
        this.circleAnimation.goToAndPlay(0);
      }

      if (this.lineAnimation) {
        this.lineAnimation.goToAndStop(0);
        this.lineAnimationStarted = false;
      }

      //center_img, rect, headline
      //gsap.from(this.$refs.center_img, { ease: "Expo.easeOut",duration: 2, x: "30%" });

      gsap.set(this.$refs.headline, {
        clearProps: "all",
      });

      gsap.set(this.$refs.rect, {
        clearProps: "all",
      });

      gsap.set(this.$refs.headline, {
        ease: "Expo.easeOut",
        x: "10%",
        alpha: 0,
        overwrite: true,
      });

      gsap.to(this.$refs.headline, {
        ease: "Expo.easeOut",
        duration: 2,
        delay: 2,
        alpha: 1,
        x: "0%",
      });

      gsap.set(this.$refs.rect, {
        x: "100%",
        overwrite: true,
      });

      gsap.to(this.$refs.rect, {
        ease: "Expo.easeOut",
        duration: 2,
        x: "0",
      });

      this.$refs.image.show();
    },
    setCircleController(animation) {
      this.circleAnimation = animation;
      if (this.shown) {
        this.circleAnimation.play();
      }
    },
    setAnimController(animation) {
      this.lineAnimation = animation;
    },
    viewHandler(e) {
      if (e.percentInView >= 1 && !this.lineAnimationStarted) {
        this.lineAnimationStarted = true;
        this.lineAnimation.goToAndPlay(0);
      }
    },
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
